import { Card, EncabezadoPaginaSkeleton, RegionCargando, Skeleton } from "@/components/ui";

/**
 * Historial de la solicitud en carga · MISMA forma que `HistorialSolicitudPage`
 * (contenedor `max-w-4xl`, encabezado con breadcrumbs, tarjeta del conteo de
 * versiones y la línea de tiempo de hitos). Es el `pendingComponent` de la ruta.
 */
export function HistorialSolicitudSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando historial…" className="mx-auto max-w-4xl px-4 py-8 md:px-6">
      <EncabezadoPaginaSkeleton conBreadcrumbs />
      <div className="flex flex-col gap-4" aria-hidden="true">
        <Card padding="md">
          <div className="flex items-start gap-3">
            <Skeleton height={34} width={34} className="shrink-0" />
            <div className="flex flex-1 flex-col gap-1.5">
              <Skeleton height={16} width="30%" />
              <Skeleton height={12} width="65%" />
            </div>
          </div>
        </Card>
        <Card padding="lg">
          <div className="flex flex-col gap-6">
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="flex gap-3">
                <Skeleton height={24} width={24} circle className="shrink-0" />
                <div className="flex flex-1 flex-col gap-2">
                  <Skeleton height={20} width={i === 0 ? 150 : 120} className="rounded-full" />
                  <Skeleton height={9} width={180} />
                  {Array.from({ length: i === 3 ? 2 : 1 }, (_, j) => (
                    <div key={j} className="flex items-center gap-2">
                      <Skeleton height={10} width={110} className="shrink-0" />
                      <Skeleton height={12} width={j === 0 ? "45%" : "35%"} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </RegionCargando>
  );
}
